/* ============================================================
   Magnifico — Global Drag/Swipe + Auto-Scroll Engine
   ============================================================
   Targets ALL CSS-animated marquee tracks site-wide:
   - .mag-fc-scroll-track  (Featured Collection product cards)
   - .mag-review-track     (Homepage reviews)
   - .mag-ig-track          (Instagram gallery)
   - .mpdp-inaction-marquee-track (PDP In Action)
   - .mpdp-press-marquee   (PDP Press logos)
   - Any element with [data-marquee]
   
   Also handles:
   - PDP gallery touch swipe
   - PDP roller (testimonials on product page)
   ============================================================ */
(function(){
  'use strict';

  /* ─── MARQUEE DRAG ENGINE ─── 
     These tracks use CSS @keyframes with translateX(-50%).
     Strategy: On grab, pause animation, capture current translateX,
     switch to manual JS transform, drag freely, then on release
     compute new offset and restart animation from that position.
  */

  var MARQUEE_SELECTORS = [
    '.mag-fc-scroll-track',
    '.mag-review-track',
    '.mag-ig-track',
    '.mpdp-inaction-marquee-track',
    '.mpdp-press-track',
    '.mpdp-proof-track',
    '.mpdp-artist-track',
    '.mpdp-review-marquee-track',
    '.mpdp-cross-track',
    '[data-marquee]'
  ];

  function getTranslateX(el) {
    var style = window.getComputedStyle(el);
    var matrix = style.transform || style.webkitTransform;
    if (!matrix || matrix === 'none') return 0;
    var values = matrix.match(/matrix\(([^)]+)\)/);
    if (values) {
      var parts = values[1].split(',');
      return parseFloat(parts[4]) || 0;
    }
    return 0;
  }

  function initMarquee(track) {
    if (!track || track.dataset.dragReady) return;
    track.dataset.dragReady = 'true';

    var state = {
      isDragging: false,
      startX: 0,
      currentX: 0,
      scrollX: 0,         // Current translateX when drag started
      velocity: 0,
      lastX: 0,
      lastTime: 0,
      rafId: null,
      animName: '',
      animDuration: 0,
      animDirection: -1,   // -1 = scrolls left
      trackWidth: 0,
      halfWidth: 0
    };

    /* Capture original animation properties */
    var cs = getComputedStyle(track);
    state.animName = cs.animationName;
    state.animDuration = parseFloat(cs.animationDuration) || 40;

    /* Calculate track width (it's duplicated so it's 2x visible) */
    function measureTrack() {
      state.trackWidth = track.scrollWidth;
      state.halfWidth = state.trackWidth / 2;
    }
    measureTrack();

    function pauseAnim() {
      track.style.animationPlayState = 'paused';
      track.style.animation = 'none';
    }

    function resumeAnimFrom(offsetX) {
      /* Normalize offset to be within -halfWidth to 0 */
      while (offsetX > 0) offsetX -= state.halfWidth;
      while (offsetX < -state.halfWidth) offsetX += state.halfWidth;

      /* Calculate what percentage through the animation this offset represents */
      var progress = Math.abs(offsetX) / state.halfWidth;
      var remainingDuration = state.animDuration * (1 - progress);

      /* Create a dynamic keyframe from current position to end */
      var startPct = (progress * 100).toFixed(2);

      /* Apply transform immediately then restart animation */
      track.style.transform = 'translateX(' + offsetX + 'px)';
      
      /* Use a micro-delay to allow the browser to paint the current position */
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          track.style.transform = '';
          track.style.animation = '';
          track.style.animationPlayState = 'running';
          
          /* Adjust animation delay to start from current offset */
          var delay = -(progress * state.animDuration);
          track.style.animationDelay = delay + 's';
        });
      });
    }

    /* --- POINTER DOWN --- */
    function onPointerDown(e) {
      /* Only exclude interactive form controls inside cards */
      var tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return;
      if (e.target.closest('button, input, select, .mag-fc-qty, .mag-fc-swatches, .mag-fc-hero-swatches, .mag-fc-btns, .mag-fc-hero-btns')) return;

      state.isDragging = true;
      state.didDrag = false;
      state.scrollX = getTranslateX(track);
      state.startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      state.currentX = state.startX;
      state.lastX = state.startX;
      state.lastTime = Date.now();
      state.velocity = 0;

      pauseAnim();
      track.style.transform = 'translateX(' + state.scrollX + 'px)';
      track.style.cursor = 'grabbing';
      track.style.transition = 'none';

      /* Prevent default to stop text selection and link drag */
      e.preventDefault();
    }

    /* --- POINTER MOVE --- */
    function onPointerMove(e) {
      if (!state.isDragging) return;
      var clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      var delta = clientX - state.startX;
      var now = Date.now();
      var dt = now - state.lastTime;

      /* Mark as actual drag if moved more than 5px */
      if (Math.abs(delta) > 5) state.didDrag = true;
      
      if (dt > 0) {
        state.velocity = (clientX - state.lastX) / dt;
      }
      state.lastX = clientX;
      state.lastTime = now;
      state.currentX = clientX;

      var newX = state.scrollX + delta;
      track.style.transform = 'translateX(' + newX + 'px)';

      e.preventDefault();
    }

    /* --- POINTER UP --- */
    function onPointerUp(e) {
      if (!state.isDragging) return;
      state.isDragging = false;
      track.style.cursor = '';

      /* If user didn't actually drag, it was a click — follow the link */
      if (!state.didDrag) {
        var target = e.target || (e.changedTouches && document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY));
        var link = target && target.closest ? target.closest('a[href]') : null;
        if (link && link.href && link.href !== '#') {
          /* Resume animation and follow the link */
          track.style.animation = '';
          track.style.animationPlayState = 'running';
          window.open(link.href, link.target || '_self');
          return;
        }
        /* No link — just resume */
        track.style.animation = '';
        track.style.animationPlayState = 'running';
        return;
      }

      var finalX = state.scrollX + (state.currentX - state.startX);

      /* Apply momentum */
      var momentum = state.velocity * 150;
      finalX += momentum;

      /* Smooth coast with momentum then restart auto-scroll */
      track.style.transition = 'transform 0.5s cubic-bezier(0.23,1,0.32,1)';
      
      /* Normalize */
      while (finalX > 0) finalX -= state.halfWidth;
      while (finalX < -state.halfWidth) finalX += state.halfWidth;
      
      track.style.transform = 'translateX(' + finalX + 'px)';

      /* After coast, restart animation */
      setTimeout(function() {
        track.style.transition = '';
        resumeAnimFrom(finalX);
      }, 550);
    }

    /* Prevent link clicks when user was dragging */
    track.addEventListener('click', function(e) {
      if (state.didDrag) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* Bind events — both mouse and touch */
    track.addEventListener('mousedown', onPointerDown);
    track.addEventListener('touchstart', onPointerDown, { passive: false });

    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: false });

    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);

    /* Hover: just pause/resume (already in CSS but reinforce) */
    track.addEventListener('mouseenter', function() {
      if (!state.isDragging) {
        track.style.animationPlayState = 'paused';
      }
    });
    track.addEventListener('mouseleave', function() {
      if (!state.isDragging) {
        track.style.animationPlayState = 'running';
      }
    });

    /* Set grab cursor */
    track.style.cursor = 'grab';
    track.style.userSelect = 'none';
    track.style.webkitUserSelect = 'none';
  }

  /* ─── PDP GALLERY: Touch Swipe ─── */
  function initPdpSwipe() {
    var mainWrap = document.getElementById('mpdp-main-img');
    var mainEl = document.getElementById('mpdp-main-img-el');
    if (!mainWrap || !mainEl) return;

    /* Preload ALL product images */
    var thumbs = document.querySelectorAll('.mpdp-thumb img');
    thumbs.forEach(function(t) {
      var img = new Image();
      img.src = t.src.replace(/width=\d+/, 'width=900');
    });

    /* Touch swipe */
    var startX = 0, startY = 0, distX = 0, swiping = false;
    mainWrap.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      distX = 0;
      swiping = true;
    }, { passive: true });

    mainWrap.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      distX = e.touches[0].clientX - startX;
      var distY = e.touches[0].clientY - startY;
      if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 10) {
        e.preventDefault();
        mainEl.style.transform = 'translateX(' + (distX * 0.3) + 'px)';
        mainEl.style.opacity = String(Math.max(0.5, 1 - Math.abs(distX) / 400));
      }
    }, { passive: false });

    mainWrap.addEventListener('touchend', function() {
      swiping = false;
      mainEl.style.transform = '';
      mainEl.style.opacity = '1';
      if (Math.abs(distX) > 50) {
        if (distX < 0 && window.mpdpNextImg) window.mpdpNextImg();
        else if (distX > 0 && window.mpdpPrevImg) window.mpdpPrevImg();
      }
    }, { passive: true });
  }

  /* ─── PDP ROLLER: Touch Swipe ─── */
  function initRollerSwipe() {
    var viewport = document.querySelector('.mpdp-roller-viewport');
    if (!viewport) return;
    
    var startX = 0, distX = 0;
    viewport.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      distX = 0;
    }, { passive: true });
    viewport.addEventListener('touchmove', function(e) {
      distX = e.touches[0].clientX - startX;
    }, { passive: true });
    viewport.addEventListener('touchend', function() {
      if (Math.abs(distX) > 50) {
        if (distX < 0 && window.mpdpRollerGo) {
          /* Next slide */
          var dots = document.querySelectorAll('.mpdp-roller-dot');
          var current = document.querySelector('.mpdp-roller-dot-active');
          if (current && current.nextElementSibling) current.nextElementSibling.click();
          else if (dots[0]) dots[0].click();
        } else if (distX > 0 && window.mpdpRollerGo) {
          var dots = document.querySelectorAll('.mpdp-roller-dot');
          var current = document.querySelector('.mpdp-roller-dot-active');
          if (current && current.previousElementSibling) current.previousElementSibling.click();
          else if (dots[dots.length - 1]) dots[dots.length - 1].click();
        }
      }
    }, { passive: true });
  }

  /* ─── INIT ─── */
  function init() {
    /* Init all marquee tracks */
    MARQUEE_SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(track) {
        initMarquee(track);
      });
    });

    /* PDP-specific */
    initPdpSwipe();
    initRollerSwipe();

    /* Preconnect hints */
    ['https://cdn.shopify.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach(function(d) {
      if (!document.querySelector('link[rel="preconnect"][href="' + d + '"]')) {
        var link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = d;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
